export interface TimeRange { start: number; end: number }

export const mergeTimeRanges = (ranges: TimeRange[]): TimeRange[] => {
  const sorted = ranges.filter(r => Number.isFinite(r.start) && Number.isFinite(r.end) && r.end > r.start)
    .map(r => ({ ...r })).sort((a, b) => a.start - b.start);
  const merged: TimeRange[] = [];
  for (const range of sorted) {
    const last = merged[merged.length - 1];
    if (last && range.start <= last.end) last.end = Math.max(last.end, range.end);
    else merged.push(range);
  }
  return merged;
};

export const subtractTimeRanges = (target: TimeRange, coveredRanges: TimeRange[]): TimeRange[] => {
  const missing: TimeRange[] = [];
  let cursor = target.start;
  for (const range of mergeTimeRanges(coveredRanges)) {
    if (range.end <= cursor) continue;
    if (range.start >= target.end) break;
    if (range.start > cursor) missing.push({ start: cursor, end: Math.min(range.start, target.end) });
    cursor = Math.max(cursor, range.end);
    if (cursor >= target.end) break;
  }
  if (cursor < target.end) missing.push({ start: cursor, end: target.end });
  return missing.filter(range => range.end > range.start);
};

export const splitTimeRangesByMaxSpan = (ranges: TimeRange[], maxSpanSeconds: number): TimeRange[] => {
  if (!Number.isFinite(maxSpanSeconds) || maxSpanSeconds <= 0) throw new Error('Invalid request span');
  const result: TimeRange[] = [];
  for (const range of ranges) {
    for (let start = range.start; start < range.end; start += maxSpanSeconds) {
      result.push({ start, end: Math.min(start + maxSpanSeconds, range.end) });
    }
  }
  return result;
};
